import groupTopicsReducer from "./groups";

export default groupTopicsReducer;
